import React from 'react';
import { cn } from '../../../utils/cn';

interface SearchRecentlySearchedPopupProps {
    recentlySearched: string[];
    clearHistory: () => void;
    onItemClick: (search: string) => void;
    variant?: 'default' | 'header';
    menuColor?: 'light' | 'dark';
}

export const SearchRecentlySearchedPopup: React.FC<
    SearchRecentlySearchedPopupProps
> = ({
    recentlySearched,
    onItemClick,
    clearHistory,
    variant = 'default',
    menuColor = 'dark',
}) => {
    return (
        <div
            className={cn(
                'absolute left-2 right-2 top-full z-popover mt-2 p-8 pt-9',
                variant === 'header' && menuColor === 'light'
                    ? 'rounded-5 bg-black/20 pl-13.5 pt-9 shadow-lg backdrop-blur-xl'
                    : variant === 'header' && menuColor === 'dark'
                      ? 'rounded-5 bg-gray-100/40 pl-13.5 pt-9 shadow-lg backdrop-blur-xl'
                      : 'rounded-xl border border-gray-300 bg-white shadow-lg'
            )}
            id="search-autocomplete"
            aria-haspopup="listbox"
        >
            <div>
                <span
                    className={cn(
                        'font-medium md:mb-4 md:text-dropdown',
                        variant === 'header' && menuColor === 'light'
                            ? 'text-white md:mb-0 md:text-dropdown'
                            : variant === 'header' && menuColor === 'dark'
                              ? 'text-gray-800 md:mb-0 md:text-dropdown'
                              : 'text-gray-800'
                    )}
                >
                    Recently Searched
                </span>
                <div className="my-4.5 space-y-2.5 md:my-2 md:space-y-0.5">
                    {recentlySearched.map((searchItem) => (
                        <div
                            key={searchItem}
                            onClick={() => onItemClick(searchItem)}
                            className={cn(
                                'flex cursor-pointer items-center focus:outline-none md:p-2',
                                variant === 'header' && menuColor === 'light'
                                    ? 'md:px-0 md:py-1 md:focus:bg-white/10'
                                    : variant === 'header' &&
                                        menuColor === 'dark'
                                      ? 'md:px-0 md:py-0.5 md:focus:bg-gray-200'
                                      : 'md:hover:bg-gray-100 md:focus:bg-gray-100'
                            )}
                            role="option"
                            tabIndex={0}
                            aria-selected={false}
                        >
                            <div
                                className={cn(
                                    'flex min-h-4.5 max-w-full items-center gap-1 whitespace-nowrap leading-[1.1] md:min-h-0',
                                    variant === 'header' &&
                                        menuColor === 'light'
                                        ? 'white border-b border-transparent md:text-dropdown md:hover:border-b md:hover:border-white'
                                        : variant === 'header' &&
                                            menuColor === 'dark'
                                          ? 'border-b border-transparent text-gray-600 md:text-dropdown md:hover:border-b md:hover:border-gray-600'
                                          : 'text-[#9b9b9b] md:text-gray-400'
                                )}
                            >
                                <span>{searchItem}</span>
                            </div>
                        </div>
                    ))}
                    <div
                        onClick={clearHistory}
                        className={cn(
                            'flex cursor-pointer items-center focus:outline-none md:p-2',
                            variant === 'header' && menuColor === 'light'
                                ? 'md:px-0 md:py-1'
                                : variant === 'header' && menuColor === 'dark'
                                  ? 'md:px-0 md:py-1'
                                  : ''
                        )}
                        role="option"
                        tabIndex={1}
                        aria-selected={false}
                    >
                        <div
                            className={cn(
                                'mt-4 flex min-h-4.5 max-w-full items-center gap-1 whitespace-nowrap leading-[1.1] md:min-h-0',
                                variant === 'header' && menuColor === 'light'
                                    ? 'text-[#c0c0c0] md:text-dropdown'
                                    : variant === 'header' &&
                                        menuColor === 'dark'
                                      ? 'text-gray-600 md:text-dropdown'
                                      : 'text-[#9b9b9b] md:text-gray-400'
                            )}
                        >
                            <span
                                className={cn(
                                    'font-medium',
                                    variant === 'header' &&
                                        menuColor === 'light'
                                        ? 'text-white md:text-dropdown'
                                        : variant === 'header' &&
                                            menuColor === 'dark'
                                          ? 'text-gray-800 md:text-dropdown'
                                          : 'text-gray-900'
                                )}
                            >
                                {`Clear History`}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
